import React from "react";
import {Text, View, StyleSheet, Image} from '@react-pdf/renderer/dist/react-pdf.es';
import i18n from "../../../../i18n";
import moment from "moment";

const styles = StyleSheet.create({
    container:{
        flexDirection: 'column',
        marginLeft: '5mm',
        marginRight:'20mm',
        fontSize: 12,
        fontFamily: 'Lato',
    },
    object:{
        marginTop:15,
        marginBottom:15,
        fontSize: 13,
        fontFamily: 'Lato Bold',
    },
    title: {
        marginTop:10,
        marginBottom:15,
        fontSize: 13,
        fontFamily: 'Lato Bold',
    },
    titleCenter:{
        marginTop:10,
        marginBottom:10,
        textAlign:'center',
        fontSize: 13,
        fontFamily: 'Lato Bold',
    },
    text: {
        marginTop:5,
        marginBottom:5,
    },
    listItem:{
        textAlign:'center',
        fontSize: 13,
        fontFamily: 'Lato Bold',
    },
    signature:{
        marginLeft:-10,
        height:'20mm',
        width:'75mm',
        zIndex:5,

    },
    image: {
        objectFit: 'contain',
        objectPosition: '5mm',
    },
    foot: {
        flexDirection:'row',
    },
    leftColumn:{
        flexDirection: 'column',
        flexGrow: 4,
    },
    rightColumn:{
        flexDirection: 'column',
        flexGrow: 2,
        alignItems: 'flex-start',
        justifyContent: 'flex-end',
    },
});

const setPageBreak = (docType,listLength) => {

    if(listLength > 0) {
        if (docType !== 'order_withdrawal') {
            return listLength > 0;
        } else {
            return listLength > 1;
        }
    }
    return false;
}

export default ({...props}) => {

    const{values} = props;

    const debug = false;

    let docType;

    if(values.order_withdrawal) {
        docType = 'order_withdrawal';
    }else if(values.second_grace_period){
        docType = 'second_grace_period';
    }else if(values.first_grace_period) {
        docType = 'first_grace_period';
    } else {
        docType = 'deadline';
    }

    let correspondence = values.correspondence ? values.correspondence : values.emails;

    let pageBreak = setPageBreak(docType,correspondence ? correspondence.length : 0)

    return (
        <View style={styles.container}>
            <Text style={styles.object}>
                {'BV: ' + ( values.building_parent &&
                    values.building_parent.name
                    + ', ' + values.building_parent.zip
                    + ' ' + values.building_parent.city
                )}
                {values.building_child_address && ', ' + values.building_child_address}
                {values.apartment_number && (', Whg. ' + values.apartment_number )}
                {values.storey && (', Etage: ' + values.storey )}
                {values.tenant_name && (', Mieter: ' + values.tenant_name)}
                {values.tenant_phone_number && (', Tel: ' + values.tenant_phone_number)}
            </Text>
            <Text style={styles.title}>
                { i18n.get('deficiency.pdf.' + docType + '_title') + ' ' +
                    (docType !== 'order_withdrawal' && docType !== 'second_grace_period'
                        ? i18n.get('deficiency.pdf.conformable_to_law')
                        : ''
                    ) }
            </Text>
            <Text style={styles.text}>
                {'Sehr geehrte Damen und Herren,'}
            </Text>
            <Text style={styles.text}>
                {values.order_withdrawal
                    ? (
                        'in nachfolgender Angelegenheit kommen wir zurück auf die Ihnen zugestellte ' +
                        'Mängelbeseitigungsaufforderung und Nachfristsetzung'
                    ) : (
                        'wir erhielten für das o.g. Objekt folgenden Mangel angezeigt:'
                    )
                }
            </Text>
            <Text style={{
                ...styles.titleCenter,
                marginBottom: values.correspondence && values.correspondence.length ? 0 : 10
            }}>
                {values.number_internal && `Mangel-Nr. ${values.number_internal}, ` }{values.name && values.name}
            </Text>
            {(correspondence && correspondence.length > 0) && correspondence.map((item,key) => {
                let text = item.text
                    ? item.text
                    : item.sent_at && item.sent_at !== 'Invalid date'
                        ? 'Siehe E-Mail von IBA vom ' + moment(item.sent_at).format('DD.MM.YYYY')
                        : null;

                let arrLength = correspondence.length;
                return text && (<Text style={{
                    ...styles.listItem,
                    marginBottom: key === arrLength-1 ? 10 : 0}} key={key}>
                    ({text})
                </Text>)
            })}
            {!values.order_withdrawal &&
                <React.Fragment>
                    <Text style={styles.text}>
                        {'Wir fordern Sie auf, nach § 13 (5) der VOB/B diesen Mangel'}
                    </Text>
                    <Text style={styles.titleCenter}>
                        {`bis zum ${moment(values[docType]).format('DD.MM.YYYY')}`}
                    </Text>
                    <Text style={styles.text}>
                        {'fachgerecht zu beseitigen. Die Abarbeitung hat in eigener Regie zu erfolgen.'}
                    </Text>
                </React.Fragment>
            }
            <Text style={styles.text}>
                {values.order_withdrawal
                    ? (
                        'Leider haben Sie die zur Mängelbeseitigung gesetzten Fristen und Nachfristen fruchtlos ' +
                        'verstreichen lassen.\n' +
                        'Entsprechend unserer Ankündigung lehnen wie hiermit die Annahme weiterer Mängelbeiseitigungsarbeiten ' +
                        'durch Sie ab. Wir werden die genannten Mängel nunmehr im Wege der Ersatzvornahme zu Ihren ' +
                        'Lasten beseitigen lassen.\n' +
                        '\n' +
                        'Sobald uns die Kosten der Ersatzvornahme bekannt sind, werden wir Ihnen diese aufgeben. ' +
                        'Bis dahin üben wir das uns gesetzlich zustehende Zurückbehaltungsrecht aus. ' +
                        'Die Geltendmachung weiterer Schadensersatzansprüche bleibt ausdrücklich vorbehalten.\n'
                    ) : (
                        'Die Erledigung ist uns schriftlich mit Unterschrift des Mieters anzuzeigen. ' +
                        'Ohne Unterschrift gilt diese Mangelanzeige als nicht erledigt. ' +
                        'Sollten Sie diesen Termin nicht wahrnehmen werden wir Ihnen nach § 8 (3) der VOB/B den Auftrag ' +
                        'dafür entziehen und auf Ihre Kosten eine Drittfirma mit der Beseitigung des Mangels beauftragen.'
                    )
                }
            </Text>
            <Text style={{...styles.text,marginTop:20,marginBottom:0}} break={pageBreak}>
                {'Mit freundlichen Grüßen'}
            </Text>
            <View style={{...styles.signature,marginTop:0}}>
                <Image style={styles.image} src={'/signature/th_weber.jpg'} debug={debug} />
            </View>
            <View style={{flexDirection:'row',marginTop:-10}}>
                <View style={styles.leftColumn}>
                    <Text>{'Thomas Weber'}</Text>
                    <Text>{'Geschäftsführer'}</Text>
                </View>
                {!values.order_withdrawal &&
                    <View style={{...styles.rightColumn, borderTop: 0.5}}>
                        <Text>{'Unterschrift Mieter'}</Text>
                        <Text>{'Freigabe erteilt'}</Text>
                        <View style={{flexDirection: 'row',width:'100%'}}>
                            <View style={{flexDirection:'column',flexGrow:1}}>
                                <Text>{'Datum:'}</Text>
                            </View>
                            <View style={{flexDirection:'column',flexGrow:1}}>
                                <Text>{'Name:'} {values.tenant_name && values.tenant_name}</Text>
                            </View>
                        </View>
                    </View>
                }
            </View>
        </View>
    );
}
